<div class="div_loading">
    <div class="my-container" [hidden]="!loading">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
    </div>
</div>

<div class="row dflex">
    <div class="col-xl-2 col-lg-2 col-md-3 col-sm-4 col-xs-12 padding0">
        <input class="search_box" name="search_all" [(ngModel)]="search_all" (keyup)="check_access(4,1,'',1,2)"
            placeholder="{{ messageService.get_search() }}" autocomplete="off" style="width:100%">
    </div>
    <div class="col-xl-8 col-lg-8 col-md-7 col-sm-8 col-xs-12 padding0">
        <div class="service_pager">
            <span>
                <div class="video_div1" (click)="open_video()" *ngIf="video">
                    <mat-icon class="video">smart_display</mat-icon>
                </div>
                <button class="search1" (click)='open_detaile(0,3,0)'>
                    <span>{{ messageService.get_filter() }}</span>
                </button>
                <button class="new1" (click)='open_detaile(0,1,0)' *ngIf="level == 1">
                    <span>{{ messageService.get_new() }}</span>
                </button>
                <div class="pager_pe">
                    <button (click)="check_access(4,4,0,1,1)" [disabled]='next_status'><i
                            class="fas fa-fast-forward"></i></button>
                    <button (click)="check_access(4,2,0,1,1)" [disabled]='next_status'><i
                            class="fas fa-forward"></i></button>
                    <button (click)="check_access(4,3,0,1,1)" [disabled]='pre_status'><i
                            class="fas fa-backward"></i></button>
                    <button (click)="check_access(4,1,0,1,1)" [disabled]='pre_status'><i
                            class="fas fa-fast-backward"></i></button>
                </div>
                <div class='navigation'><span> {{ page_number_first }}
                    </span><span>-</span><span> {{ page_number_second }} </span><span> of </span><span>
                        {{ count_total }} </span>
                </div>
            </span>
        </div>
    </div>
    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-6 col-xs-12 padding0 hidden-sm hidden-xs">
        <div class="pager_checkbox">
            <div class="pager_icon_en">
                <div class="excel">
                    <img src="../../../../../assets/images/excel.png" class="excel_icon cursor"
                        (click)="load_data(1,2,1,-1,false)">
                    <a href="" id="excel"><i class="far fa-file-excel" [hidden]="true"></i></a>
                </div>
            </div>
        </div>
    </div>
</div>


<div class="content-body control-content-body" (window:resize)="change_resize()">
    <mat-table [dataSource]="dataSource" class='table-scroll mat_table_fa_without_scroll pe1'>

        <ng-container matColumnDef="row">
            <mat-header-cell *matHeaderCellDef style='max-width:45px'>
                <span (click)="update_user_date()">.ردیف</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style='max-width:45px'>{{ i +
                page_number_first }}</mat-cell>
            <mat-footer-cell *matFooterCellDef style='max-width:45px'></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="how_to_charge">
            <mat-header-cell *matHeaderCellDef>
                <span>نحوه شارژ</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index">
                {{ x.how_to_charge_title }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="comment">
            <mat-header-cell *matHeaderCellDef style="min-width:250px">
                <span>شرح پرداختی</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.site_bascket_id)"
                style="min-width:250px">
                <div class="right">
                    {{ x.title }}
                </div>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef style='min-width:250px'></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="user_title">
            <mat-header-cell *matHeaderCellDef [hidden]="level != 1" style="min-width: 180px;">
                <span>نام کاربر</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.site_bascket_id)"
                [hidden]="level != 1" style="min-width: 180px;">
                <div class="right">{{ x.user_title }}</div>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef [hidden]="level != 1" style="min-width: 180px;"></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="account">
            <mat-header-cell *matHeaderCellDef [hidden]="level != 1" style="min-width:200px">
                <span>عنوان فروشگاه</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.site_bascket_id)"
                [hidden]="level != 1" style="min-width:200px">
                <div class="right">{{ x.user_store | substr:0:30 }}
                </div>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef [hidden]="level != 1" style="min-width:200px"></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="expire">
            <mat-header-cell *matHeaderCellDef [hidden]="code == 230 || level != 1" style="max-width: 120px;">
                <span>تاریخ انقضا</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.site_bascket_id)"
                [hidden]="code == 230 || level != 1" style="max-width: 120px;">
                <div>{{ x.site_bascket_expire_date }}</div>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef style='max-width: 120px'
                [hidden]="code == 230 || level != 1"></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="amount">
            <mat-header-cell *matHeaderCellDef style="max-width: 180px;min-width: 180px;">
                <span>مقدار شارژ</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.site_bascket_id)"
                style="max-width: 180px;min-width: 180px;">
                {{ x.site_bascket_amount | number }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef style='max-width: 180px;min-width: 180px;'>{{ sum | number
                }}</mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="coupon">
            <mat-header-cell *matHeaderCellDef style="max-width: 180px;">
                <span>کوپن</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.site_bascket_id)"
                style="max-width: 180px;">
                {{ x.site_coupon_title }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef style='max-width: 180px;min-width: 180px;'></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="code">
            <mat-header-cell *matHeaderCellDef style="min-width:150px" [hidden]="level != 1">
                <span>کد رهگیری</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.site_bascket_id)"
                style="min-width:150px" [hidden]="level != 1">
                {{ x.site_bascket_code }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef style='min-width:150px' [hidden]="level != 1"></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="date">
            <mat-header-cell *matHeaderCellDef style="max-width:120px">
                <span>تاریخ ثبت</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.site_bascket_id)"
                style="max-width:120px">
                {{ x.site_bascket_date }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef style='max-width:120px'></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="time">
            <mat-header-cell *matHeaderCellDef style="max-width:120px">
                <span>ساعت ثبت</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.site_bascket_id)"
                style="max-width:120px">
                {{ x.site_bascket_time }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef style='max-width:120px'></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="id">
            <mat-header-cell *matHeaderCellDef style="max-width:120px">
                <span>شناسه</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" (click)="open_detaile(i,2,x.site_bascket_id)"
                style="max-width:120px">
                {{ x.site_bascket_id }}
            </mat-cell>
            <mat-footer-cell *matFooterCellDef style='max-width:120px'></mat-footer-cell>
        </ng-container>

        <ng-container matColumnDef="operation">
            <mat-header-cell *matHeaderCellDef style='max-width:50px' [hidden]="level != 1">
                <span>عملیات</span>
            </mat-header-cell>
            <mat-cell *matCellDef="let x;let i = index" style='max-width:50px' [hidden]="level != 1">
                <span class="operation-icon" (click)="delete(x.site_bascket_id,x.user_id)"><i
                        class="far fa-trash-alt icon" style='margin:0px 4px;'></i></span>
            </mat-cell>
            <mat-footer-cell *matFooterCellDef style='max-width:50px' [hidden]="level != 1"></mat-footer-cell>
        </ng-container>

        <mat-header-row *matHeaderRowDef="displayedColumns" color="primary"></mat-header-row>
        <mat-row *matRowDef="let row;columns:displayedColumns;let i = index" (click)="mat_table_selectedRow = row"
            (mouseenter)="mat_table_hoverRow = row"
            [ngClass]="{'mat_table_selected': row === mat_table_selectedRow,mat_table_selected2:row.checked == true,'mat_table_hover': row === mat_table_hoverRow}"
            class="cursor"></mat-row>
        <mat-footer-row style="background: rgb(245 245 163) !important;bottom:-2px"
            *matFooterRowDef="displayedColumns;sticky : true"></mat-footer-row>
    </mat-table>

    <div class="row" class="preview1" [hidden]="count_total > 0">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div>
                <img src="../../../assets/images/preview2.png">
            </div>
            <div class="preview2">{{ messageService.get_no_record_text() }}</div>
        </div>
    </div>
</div>